export const appusers = {
  appusersSearch: 'Cerca'
}
